import { render, staticRenderFns } from "./SelectionBlockCategoryEmployees.vue?vue&type=template&id=507e55ca&scoped=true&"
import script from "./SelectionBlockCategoryEmployees.vue?vue&type=script&lang=js&"
export * from "./SelectionBlockCategoryEmployees.vue?vue&type=script&lang=js&"
import style0 from "./SelectionBlockCategoryEmployees.vue?vue&type=style&index=0&id=507e55ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e55ca",
  null
  
)

export default component.exports